import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import React from 'react';
// Consts and Libs
import AppAPI from '../../lib/api';
import AppUtil from '../../lib/util';
import { Strings } from '../../constants';
// Components
import EventListView from './components/EventListView';
import ListView from '../../components/general/ListView';
import PageHeader from '../../components/booking-engine/PageHeader';

import { faCampground } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/* Redux ==================================================================== */
// What data from the store shall we send to the component?
const mapStateToProps = (state) => ({
  property: state.property.property
});

// Any actions to map to the component?
const mapDispatchToProps = {};

/* Component ==================================================================== */
const EventList = (props) => {
  const { property } = props;
  const { booking_engine_content } = property;

  const fetchData = (page, callback) => {
    AppAPI.bengineapi.get(`${property.property_slug}/event/?${page && `page=${page}`}`)
      .then((res) => {
        const params = { nextParam: res.next ? AppUtil.getURLParam(res.next, 'page') : false };
        res.results.length > 0 ? callback(res.results, params) : callback();
      })
      .catch((err) => {
        callback();
        AppAPI.handleError(err);
      });
  };

  const emptyView = () => {
    return (
      <div className={'col-12 text-center mb-5'}>
        <div className={'w-50 mx-auto mb-5'}>
          <img alt={'Empty Events'} className="w-100" src={require('../../images/resource/cycling-bg.png')}/>
        </div>
        <p>{Strings.eventsEmptyText}</p>
      </div>
    );
  };

  const renderRow = (data, key) => {
    return (
      <div className={'col-sm-6 col-md-4 col-lg-3 mb-3'} key={key}>
        <EventListView data={data}/>
      </div>
    );
  };

  return (
    <div className={'screen-container'}>
      <Helmet>
        <title>{`Events : ${property.name}`}</title>
        <meta name="description" content={`All events in ${property.name}. ${booking_engine_content.meta_description}`}/>

      </Helmet>

      <div className={'container'}>
        <div className={'row'}>
          <div className={'col-12'}>
            <PageHeader
              icon={<FontAwesomeIcon icon={faCampground} className={'me-2 grey-cl'}/>}
              title={'Event(s)'}
              back={false}
            />
            <div className={'row'}>
              <ListView
                rowView={renderRow}
                onFetch={fetchData}
                firstLoader={true}
                emptyView={emptyView}
                pagination
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Element = connect(mapStateToProps, mapDispatchToProps)(EventList);

/* Export ==================================================================== */
const EventListPage = {
  element: <Element/>
};

export default EventListPage;
